module.exports = __webpack_public_path__ + "static/media/Decisions_Step2_Image13.bcab3bd4.webp";